import { render, staticRenderFns } from "./ResumeViewTitle.vue?vue&type=template&id=21ad3515&scoped=true&"
import script from "./ResumeViewTitle.vue?vue&type=script&lang=ts&"
export * from "./ResumeViewTitle.vue?vue&type=script&lang=ts&"
import style0 from "./ResumeViewTitle.vue?vue&type=style&index=0&id=21ad3515&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ad3515",
  null
  
)

export default component.exports